import React from "react";
import ServiceOne from "../../assets/home-loan-img.png";
import { useNavigate } from "react-router-dom";
import { FaImage, FaIdCard, FaFileAlt, FaHome, FaUsers, FaMoneyBillWave  } from "react-icons/fa";
import { MdOutlineDescription } from "react-icons/md";


const HomeLoanOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "home",
      title: "Home Loan",
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  return (
    <div className="loan-offer-wrapper">
      <div className="ourservice-logo">
        <div className="ourservice-text">
          <h2 className="ourservice-offer-subtitle">Home Loan</h2>
        </div>
        <p className="offer-title-ourservice offer-submain-title">
          {" "}
          Get Home Loan From{" "}
          <span className="highlight-color">₹ 10 Lakh to ₹10 Crore*</span>
        </p>
      </div>

      <div className="loan-highlights">
        <div className="salary-rate-pair">
          <div className="salary-rate-list">
            <div className="salary-rate-box">
              <p>Funding Available</p>
              <h3>100%*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Interest Rate Starts @</p>
              <h3>7.35%*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Tenure up to</p>
              <h3>30*</h3>
              <p>Months</p>
            </div>
            <div className="salary-rate-box">
              <p>EMI </p>
              <h3>₹689*</h3>
              <p>P/M</p>
            </div>
          </div>
        </div>
        <p className="offer-subtitle highlight-rate">
          Construction, Purchases , Residential, and Commercial property
        </p>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Who Can Apply</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>CIBIL 700 & Above
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>All Salaried,Self
              Employed,Doctors & NRI
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Age 21 to 65
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>For Salaried -Minimum
              Net Salary 30000 P/M
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>For Self Employed
              -Minimum 6 Lakhs Annual Turn Over Required
            </p>
          </div>
        </div>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Documents</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Selfie (or ) Photo
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Pan
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Aadhaar or E-Aadhaar
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>For Salaried-Last 6
              Month Account Statement & Last 3 Month Pay Slip
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>For Self Employed -Last
              12 Month Current/Savings Account Statement & Last 2 Years ITR
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Property Documents
            </p>
          </div>
        </div>
      </div>
      <div className="offer-subtitle">
        <p>
          <span className="highlight-rate">Service Available All Over Tamil Nadu</span><br />
          (Right Lender Serviceable PIN code)
        </p>
      </div>

      <div className="apply-now-button">
        {plans.map((plan, index) => (
          <button
            className="apply-loan-button"
            key={index}
            onClick={() => handleApplyClick(plan.loanType)}
          >
            Proceed
          </button>
        ))}
      </div>
    </div>
  );
};

export default HomeLoanOffer;
